<template>
  <div v-if="email">
    <span v-if="emailValidationResult && emailLastVerifiedAt">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }" >
          <v-chip class="mr-2"
                  :color="colorEmailVerify"
                  label
                  v-on="on"
                  text-color="white"
                  x-small>
             {{'EmailVerify:'+ ' '}} <strong> {{ emailValidationResult }}</strong>
          </v-chip>
        </template>
        <span>{{ emailLastVerifiedAt }}</span>
      </v-tooltip>
    </span>

    <span v-else-if="emailValidationResult">
      <v-chip class="mr-2"
              :color="colorEmailVerify"
              label
              text-color="white"
              x-small>
        {{'EmailVerify:'+ ' '}} <strong> {{ emailValidationResult }}</strong>
      </v-chip>
    </span>

    <span>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="d-inline elevation-0"
            color="kbGreen"
            :loading="verifyingEmail"
            fab
            dark
            height="20"
            width="20"
            x-small
            @click="verifyEmail()"
            v-on="on">
            <v-icon x-small>mdi-check</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('general.verifyEmail') }}</span>
      </v-tooltip>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import notifications from '@/libs/notifications'
export default {
  computed: {
    ...mapGetters(['appUuid', 'companyUuid']),
    colorEmailVerify () {
      if (this.emailValidationResult === 'ok' || this.emailValidationResult === 'ok_for_all') {
        return '#69F0AE'
      } else if (this.emailValidationResult === 'antispam_system' || this.emailValidationResult === 'accept_all' || this.emailValidationResult === 'diposable') {
        return '#EEFF41'
      } else if (this.emailValidationResult === 'error' || this.emailValidationResult === 'smtp_error' || this.emailValidationResult === 'unknown_email' ||
        this.emailValidationResult === 'attempt_reject' || this.emailValidationResult === 'relay_error' || this.emailValidationResult === 'email_disabled' ||
        this.emailValidationResult === 'domain_error' || this.emailValidationResult === 'dead_server' || this.emailValidationResult === 'syntax_error' ||
        this.emailValidationResult === 'unknown' || this.emailValidationResult === 'spamtrap' || this.emailValidationResult === 'key not valid') {
        return '#e57373'
      } else {
        return '#616161'
      }
    }
  },
  data () {
    return {
      verifyingEmail: false
    }
  },
  methods: {
    async verifyEmail () {
      this.verifyingEmail = true
      try {
        const result = await this.$store.dispatch('verifyEmail', { email: this.email, appId: this.appUuid, companyId: this.companyUuid })
        if (!result.flag) {
          notifications.error(this.$t('general.updateAppPublicKey'))
        } else {
          notifications.success(this.$t('general.emailSuccessfullyVerified'))
        }
        this.verifyingEmail = false
        this.$emit('onEmailValidated')
      } catch (e) {
        this.verifyingEmail = false
        notifications.error(e.message)
        throw e
      }
    }
  },
  props: {
    emailValidationResult: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    emailLastVerifiedAt: {
      type: [Date, String],
      default: ''
    }
  }
}
</script>
